<template>
  <v-dialog v-model="dialogShow" persistent width="90%" height="90%" max-width="1180" max-height="870">
    <v-card>
      <v-card-title style="box-shadow: 0 2px 7px 0 #A6A6A63F;font-weight:bold;">
        配置定位信息
        <v-spacer></v-spacer>
        <p @click="hideDialog" style="font-size:14px;color:#A6A6A6;cursor:pointer;" class="iconfontFamily">&#xe60d;</p>
      </v-card-title>
      <v-card-text>
        <div style="width:100%;height:calc(90vh - 58px - 20px);max-height:792px;">
          <!--地图-->
          <div style="position:relative;height:calc(100% - 60px)">
            <div id="choosePositionDialogMap" style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:0">
              <!--地图信息-->
              <div class="mapboxInfo px-5">
                <p style="line-height:25px;">吉林一号·共生地球</p>
                <v-spacer></v-spacer>
                <p style="line-height:25px;">{{mapInfoLng}}&nbsp;&nbsp;&nbsp;{{mapInfoLat}}</p>
              </div>
            </div>

            <!--功能区-->
            <div class="toolbarArea">
              <div style="width:30px;height:100%;">
<!--                <div class="toolbarArea-button" style="height:30px;">-->
<!--                  <p class="toolbarArea-button-icon iconfontFamily">&#xe622;</p>-->
<!--                </div>-->
                <div class="toolbarArea-button" style="height:60px;margin-top:3px;">
                  <div @click="map.setZoom(map.getZoom()+1)" style="height:30px;">
                    <p class="toolbarArea-button-icon iconfontFamily">&#xe60b;</p>
                  </div>
                  <div @click="map.setZoom(map.getZoom()-1)" style="height:30px;">
                    <p class="toolbarArea-button-icon iconfontFamily">&#xe629;</p>
                  </div>
                </div>
              </div>
              <!--图层切换-->
              <div @mouseenter="mapLayersHover = true;" @mouseleave="mapLayersHover = false;"
                   :style="{'background':mapLayersHover ? 'rgba(255, 255, 255, 0.7)' : 'transparent','width':mapLayersHover ? '176px' : 'auto'}"
                   style="position:relative;height:66px;border-radius:2px;margin-right:5px;">
                <div @click="changeMapLayer('tianditu')" :style="{'left':mapLayersHover ? '0' : '-13px','border':currMapLayer==='tianditu'?'1px solid #1976D2':'1px solid transparent'}" class="toolbarArea-tianditu">
                  <div v-if="currMapLayer === 'tianditu' && mapLayersHover" class="toolbarArea-layerTopBar">
                    <v-checkbox v-model="mapRoadShow" label="显示路网" dense hide-details dark color="#43CF7C" style="margin-top:-2px;"></v-checkbox>
                  </div>
                  <div class="toolbarArea-layerName">
                    <p style="line-height:19px;">地图</p>
                  </div>
                </div>
                <div @click="changeMapLayer('satellite')" :style="{'border':currMapLayer==='satellite'?'1px solid #1976D2':'1px solid transparent'}" class="toolbarArea-satellite">
                  <div v-if="currMapLayer === 'satellite'&& mapLayersHover" class="toolbarArea-layerTopBar">
                    <v-checkbox v-model="mapRoadShow" label="显示路网" dense hide-details dark color="#43CF7C" style="margin-top:-2px;"></v-checkbox>
                  </div>
                  <div class="toolbarArea-layerName">
                    <p style="line-height:19px;">遥感</p>
                  </div>
                </div>

              </div>



            </div>

            <!--搜索-->
            <div style="position:absolute;top:16px;left:16px;width:361px;">
              <v-text-field v-model="keyword" @keyup.enter.native="enterInSearchInput" @focus="searchInputFocus" dense outlined placeholder="搜索地点" solo clearable hide-details background-color="#ffffff"></v-text-field>
              <div v-if="positionSearchResultShow" style="width:calc(100% - 2px);margin:0 auto;border-radius:4px;">
                <!--结果列表-->
                <v-list v-if="positionList.length !== 0" dense style="background:transparent;" class="py-0">
                  <v-list-item-group style="background:rgba(255, 255, 255, 0.9);">
                    <v-list-item @click="choosePosition(item)" v-for="(item,index) in positionList" :key="index" class="px-3">
                      <v-list-item-title style="font-size:14px;color:#000000;">
                        <span style="font-size:16px;" class="iconfontFamily mr-2">&#xe61f;</span>
                        {{item.name}}
                        <span style="color:#808080;" class="ml-5">{{item.city}}</span>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <!--无结果-->
                <div v-if="positionList.length === 0" style="width:100%;height:100px;background:rgba(255, 255, 255, 0.95);" class="px-4 pt-3">
                  <p style="color:#000000;">未找到相关地点。</p>
                  <p style="color:#A6A6A6;" class="mt-1">缺少地理坐标？请于<span style="color:#1976D2;">首页-遇到问题-用户反馈</span>处进行反馈。</p>
                </div>
              </div>
            </div>


          </div>
          <!--底栏-->
          <div style="width:100%;height:60px;display:flex;padding-top:15px;">
            <div style="flex:1;text-align:center;padding-left:50px;">
              <p style="line-height:30px;font-size:14px;">
                <span style="color:#1976D2" class="iconfontFamily mr-2">&#xe628;</span>
                <!--无定位地点-->
                <span v-if="positionCity === '' && positionName === ''" style="color:#a6a6a6;">请搜索或在地图上点击进行内容定位</span>

                <!--定位地点-->
                <span v-if="(positionCity !== '' || positionName !== '') && !positionEditing" style="color:#000000;">
                  {{positionCity}} · {{positionName}}
                  <span @click="editPositionName" style="color:#1976D2;cursor:pointer;" class="ml-8">编辑</span>
                </span>

                <!--编辑-->
                <span v-if="(positionCity !== '' || positionName !== '') && positionEditing" style="color:#000000;">
                  {{positionCity}} ·
                  <v-text-field v-model="positionName" dense clearable hide-details background-color="#ffffff" color="#808080" style="width:200px;font-size:14px;display:inline-block;"></v-text-field>
                  <v-btn @click="positionEditing=false;" height="25" dark color="#1E3A8A" class="ml-5">保存</v-btn>
                </span>
              </p>
            </div>
            <v-btn @click="choosePositionOK" height="30" dark :color="((positionCity !== '' && (positionName !== '' && positionName !== null)) && !positionEditing) ? '#1E3A8A' : '#8F9DC5'" style="margin-top:2px;">确定</v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>


    <!--loading弹窗-->
    <dialog-loading :dialog-show="showLoadingDialog"></dialog-loading>

  </v-dialog>

</template>

<script>
import mapboxgl from 'mapbox-gl'
import positionIcon from '/src/assets/mapbox/icon.png'
import DialogLoading from '/src/components/loading/DialogLoading'
export default {
  name: "ChoosePositionDialog",
  components: {
    DialogLoading
  },
  props:["positionGeoJson","positionGeoName","dialogShow"],
  data(){
    return{

      map:"",
      mapInfoLng:"",
      mapInfoLat:"",
      currMapLayer:"satellite",
      mapRoadShow:false,
      mapLayersHover:false,




      keyword:"",
      positionSearchResultShow:false,

      positionList:[],
      oldPositionName:"",
      positionName:"",
      positionCity:"",
      positionLng:"",
      positionLat:"",


      positionEditing:false,


      positionIconFeatures:[],

      clickMapboxTimeout:"",


      showLoadingDialog:false,


    }

  },
  watch:{
    //搜索关键字变化
    keyword(){

      if(this.keyword !== null && this.keyword !== ""){
        this.$axios({
          method:"get",
          url:"/authorApi/POI/search",
          params:{
            keyWord:this.keyword,
            lat:"",
            lon:""
          }
        }).then((resultData)=>{
          resultData = resultData.data;
          if(resultData.message === "ok"){
            this.positionList = resultData.result;
            this.positionSearchResultShow = true;

            // this.positionName = this.oldPositionName;
            this.positionEditing = false;
          }
          else{
            console.log(resultData.status + resultData.message);
          }
        }).catch((err)=>{
          console.log(err);
        });

      }
      else{

        this.positionSearchResultShow = false;
      }
    },
    //路网图层显隐
    mapRoadShow(){
      if(this.mapRoadShow){
        this.map.addLayer({
          id: 'roadInfo',
          type: 'raster',
          source: 'roadInfo'
        },"positionMapIcon");
      }
      else{
        this.map.removeLayer('roadInfo')
      }
    }
  },

  methods:{
    //初始化mapbox
    initMapbox() {
      mapboxgl.accessToken = this.$utils.mapboxToken;
      this.map = new mapboxgl.Map({
        container: 'choosePositionDialogMap',
        zoom: 3,
        center:[90.94487491007658, 39.86471240059555],
        style: this.$utils.mapboxStyle,
        maxZoom: 17,
        minZoom: 0,
        transformRequest: (url) => {
          if (url.indexOf('https://api.mapbox.com') > -1) { //resourceType != 'Tile' &&
            return {
              url: url.replace('https://api.mapbox.com','https://earth.jl1.cn/mapbox'),
            };
          }
        },
      });
      this.map.on('load', ()=>{
        //全国一张图
        this.map.addSource('world1m2021', {
          type: 'raster',
          tiles: [
              this.$utils.world1m2021
          ],
          tileSize: 256,
          scheme: 'tms'
        });
        this.map.addSource('tianditu', {
          type: 'raster',
          tiles: [
            this.$utils.tianditu
          ],
          tileSize: 256,
        });
        this.map.addLayer({
          id: 'layer',
          type: 'raster',
          source: 'world1m2021'
        });

        this.map.addSource('roadInfo', {
          type: 'raster',
          tiles: [
              'https://t0.tianditu.gov.cn/DataServer?T=cva_w&X={x}&Y={y}&L={z}&tk=f5e247a85a4e7b9a605370d0f769d080'
          ],
          tileSize: 256,
        });


        //地图上定位图标
        let _this = this;
        this.map.loadImage(
            positionIcon,
            function(error,image){
              if(error) throw error;
              _this.map.addImage("positionIcon",image);
            }
        )
        this.map.addSource('positionMapIcon', {
          type: 'geojson',
          data: {
            'type': 'FeatureCollection',
            'features': []
          }
        });
        this.map.addLayer({
          id: 'positionMapIcon',
          type: 'symbol',
          source: 'positionMapIcon',
          layout: {
            "icon-image": ["get", "icon"],
            // "icon-size": 0.25
          }
        });

        //监听点击地图
        this.map.on('click', (e)=>{
          this.clickMapbox(e);
        })

        //初始经纬度信息
        this.mapInfoLng = Math.abs(this.map.getCenter().lng).toFixed(3) + 'º' + ((this.map.getCenter().lng < 0) ?  'W' : 'E');
        this.mapInfoLat = Math.abs(this.map.getCenter().lat).toFixed(3) + 'º' + ((this.map.getCenter().lat < 0) ?  'S' : 'N');
        //监听鼠标移动，获取经纬度等信息
        this.map.on('mousemove', (e)=>{
          this.mapInfoLng = Math.abs(e.lngLat.lng).toFixed(3) + 'º' + ((e.lngLat.lng < 0) ?  'W' : 'E');
          this.mapInfoLat = Math.abs(e.lngLat.lat).toFixed(3) + 'º' + ((e.lngLat.lat < 0) ?  'S' : 'N');
        })
        this.map.on('mouseout', ()=>{
          this.mapInfoLng = Math.abs(this.map.getCenter().lng).toFixed(3) + 'º' + ((this.map.getCenter().lng < 0) ?  'W' : 'E');
          this.mapInfoLat = Math.abs(this.map.getCenter().lat).toFixed(3) + 'º' + ((this.map.getCenter().lat < 0) ?  'S' : 'N');
        })

        //比例尺
        const scale = new mapboxgl.ScaleControl({
          maxWidth: 100,
          unit: 'metric',
        });
        this.map.addControl(scale, 'bottom-right');
        document.querySelector('.mapboxgl-ctrl-scale').style.marginRight = '160px'
        document.querySelector('.mapboxgl-ctrl-scale').style.marginBottom = '5px'
        document.querySelector('.mapboxgl-ctrl-scale').style.backgroundColor = 'transparent'
        document.querySelector('.mapboxgl-ctrl-scale').style.color = 'white'
        document.querySelector('.mapboxgl-ctrl-scale').style.borderColor = 'white'
        document.querySelector('.mapboxgl-ctrl-scale').style.zIndex = '1'
        document.querySelector('.mapboxgl-ctrl-scale').style.height = '6px'
        document.querySelector('.mapboxgl-ctrl-scale').style.lineHeight = '0px'
        document.querySelector('.mapboxgl-ctrl-scale').style.paddingBottom = '6px'
        document.querySelector('.mapboxgl-ctrl-scale').style.pointerEvents = 'none'

        this.showLoadingDialog = false;


        //有初始地点信息
        if(this.positionGeoJson !== "" && this.positionGeoName !== ""){
          this.positionName = this.positionGeoName.split(" · ")[1]
          this.oldPositionName = this.positionName;
          this.positionCity = this.positionGeoName.split(" · ")[0]
          this.positionLng = JSON.parse(this.positionGeoJson).coordinates[0];
          this.positionLat = JSON.parse(this.positionGeoJson).coordinates[1];
          this.map.getSource('positionMapIcon').setData({
            'type': 'FeatureCollection',
            'features': [{
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: [this.positionLng, this.positionLat]
              },
              //使用图片做point
              properties: {
                icon: "positionIcon",
              },
            }]
          });
          this.mapFlyTo(this.positionLng,this.positionLat)


        }

      });
    },
    //切换图层
    changeMapLayer(type){
      if(type === "tianditu"){
        if(this.currMapLayer !== "tianditu"){
          if(this.map.getLayer('layer')!==undefined){
            this.map.removeLayer('layer')
          }
          if(this.mapRoadShow){
            this.map.addLayer({
              id: 'layer',
              type: 'raster',
              source: "tianditu"
            },"roadInfo")
          }
          else{
            this.map.addLayer({
              id: 'layer',
              type: 'raster',
              source: "tianditu"
            },"positionMapIcon")
          }
          this.currMapLayer = "tianditu"
        }
      }
      else{
        if(this.currMapLayer !== "satellite"){
          if(this.map.getLayer('layer')!==undefined){
            this.map.removeLayer('layer')
          }
          if(this.mapRoadShow){
            this.map.addLayer({
              id: 'layer',
              type: 'raster',
              source: "world1m2021"
            },"roadInfo")
          }
          else{
            this.map.addLayer({
              id: 'layer',
              type: 'raster',
              source: "world1m2021"
            },"positionMapIcon")
          }
          this.currMapLayer = "satellite"
        }
      }


    },

    //选择搜索地点结果项
    choosePosition(item){
      this.positionName = item.name;
      this.positionCity = item.city;
      this.positionLng = item.location.lng;
      this.positionLat = item.location.lat;
      this.map.getSource('positionMapIcon').setData({
        'type': 'FeatureCollection',
        'features': [{
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [item.location.lng, item.location.lat]
          },
          //使用图片做point
          properties: {
            icon: "positionIcon",
          },
        }]
      });
      this.positionSearchResultShow = false;
      this.mapFlyTo(this.positionLng,this.positionLat)
    },

    //在搜索关键字栏点击回车
    enterInSearchInput(){
      if(this.positionList.length !== 0){
        this.choosePosition(this.positionList[0])
      }
    },
    //搜索栏获得焦点
    searchInputFocus(){
      if(this.keyword !== null && this.keyword !== ""){
        this.positionSearchResultShow = true
      }
    },

    //点击地图
    clickMapbox(e){
      //加图标，获取信息，隐藏搜索结果 隔两秒飞到位置
      if(this.clickMapboxTimeout !== ""){
        clearTimeout(this.clickMapboxTimeout)
      }
      this.positionSearchResultShow = false;
      this.positionEditing = false;
      this.positionLng = e.lngLat.lng;
      this.positionLat = e.lngLat.lat;
      this.map.getSource('positionMapIcon').setData({
        'type': 'FeatureCollection',
        'features': [{
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [this.positionLng, this.positionLat]
          },
          //使用图片做point
          properties: {
            icon: "positionIcon",
          },
        }]
      });
      //隔两秒飞到位置
      this.clickMapboxTimeout = setTimeout(()=>{
        this.mapFlyTo(this.positionLng,this.positionLat)
      },2000)

      //获取地址信息
      this.$axios({
        method:"get",
        url:"/authorApi/POI/searchFromLocation",
        params:{
          lat:this.positionLat,
          lon:this.positionLng
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.message === "ok"){
          this.positionName = resultData.result.name;
          this.positionCity = resultData.result.city;
          // this.positionLng = resultData.result.location.lng;
          // this.positionLat = resultData.result.location.lat;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });




    },

    //地图飞到位置
    mapFlyTo(lng,lat){
      if(this.map.getZoom() < 15){
        this.map.flyTo({
          center: [parseFloat(lng), parseFloat(lat)],
          zoom: 15
        })
      }
      else{
        this.map.flyTo({
          center: [parseFloat(lng), parseFloat(lat)]
        })
      }
    },


    //编辑地点名
    editPositionName(){
      this.oldPositionName = this.positionName;
      this.positionEditing = true;
    },




    //确定选择定位地点
    choosePositionOK(){
      if(((this.positionCity !== '' && (this.positionName !== '' && this.positionName !== null)) && !this.positionEditing)){
        //合法
        this.$emit("choosePositionOK",{
          city:this.positionCity,
          name:this.positionName,
          lng:this.positionLng,
          lat:this.positionLat
        })
        this.hideDialog();
      }
    },


    //隐藏弹窗
    hideDialog(){
      this.$emit("hideChoosePositionDialog")
    }



  },

  mounted(){
    this.showLoadingDialog = true;

    let temp = setInterval(()=>{
      if(this.$store.state.mapboxTokenIndex){
        this.initMapbox();
        clearInterval(temp)
      }
    })

  }


}
</script>

<style scoped>
.toolbarArea{
  position:absolute;
  bottom:35px;
  right:16px;
  height:66px;
  display:flex;
  flex-direction:row-reverse;
  align-items:flex-end;
}
.toolbarArea-tianditu{
  position:absolute;
  width:80px;
  height:60px;
  margin:3px 4px;
  border-radius:2px;
  float:left;
  cursor:pointer;
  background-size:cover;
  background-position: center;
  background-image:url("../../../src/assets/mapbox/tianditu.png")
}
.toolbarArea-satellite{
  position:relative;
  width:80px;
  height:60px;
  margin:3px 4px;
  border:1px solid #1976D2;
  border-radius:2px;
  float:right;
  cursor:pointer;
  background-size:cover;
  background-position: center;
  background-image:url("../../../src/assets/mapbox/satellite.png")
}
.toolbarArea-layerTopBar{
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:22px;
  background:rgba(0, 0, 0, 0.5);
  color:#ffffff;
}


.toolbarArea-layerName{
  position:absolute;
  bottom:2px;
  right:3px;
  width:35px;
  height:19px;
  background:rgba(30, 58, 138, 0.5);
  border-radius:2px;
  color:#ffffff;
  text-align:center;
}


.toolbarArea-button{
  width:30px;
  height:30px;
  background:#000000;
  border-radius:4px;
  text-align:center;
  cursor:pointer;
}
.toolbarArea-button-icon{
  line-height:30px;
  font-size:16px;
  color:#ffffff;
}



.mapboxInfo{
  position:absolute;
  z-index:1;
  bottom:0;
  left:0;
  width:100%;
  height:25px;
  background:rgba(0,0,0,0.5);
  display:flex;
  color:#ffffff;
  font-size:12px;
}

</style>

<style>

.toolbarArea-layerTopBar .v-input--selection-controls__input{
  width:10px;
  height:10px;
  margin-left:8px;
  margin-right:6px;
}
.toolbarArea-layerTopBar .v-input--selection-controls__ripple{
  width:0 !important;
  height:0 !important;
}
.toolbarArea-layerTopBar .v-label{
  font-size:12px;
  color:#ffffff;
}


</style>



